import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@anecdotes/configuration-data-access';

/** @deprecated Use this service from @anecdotes/utils */
@Injectable()
export class LoggerService {
  private readonly appConfig = inject(APP_CONFIG);

  log(log: any): void {
    if (!this.appConfig.production) {
      /* eslint-disable no-console */
      console.log(log);
    }
  }

  error(err: Error): void {
    if (!this.appConfig.production) {
      /* eslint-disable no-console */
      console.error(err);
    }
  }
}
